import a from "./td-longtail-vue-components123.js";
import n from "./td-longtail-vue-components98.js";
var o = function() {
  var r = this, s = r._self._c, e = r._self._setupProxy;
  return e.src && r.renderWithoutFigure ? s(e.ImageElement, r._b({ attrs: { alt: r.alt, src: e.src, lazy: r.lazy }, on: { "image-error": function(t) {
    return r.$emit("image-error", t);
  } } }, "ImageElement", e.passThroughProps, !1)) : e.src ? s(e.PictureElement, r._b({ attrs: { alt: r.alt, src: e.src, "src-sm": e.srcSm, lazy: r.lazy }, on: { "image-error": function(t) {
    return r.$emit("image-error", t);
  } } }, "PictureElement", e.passThroughProps, !1)) : r._e();
}, l = [], m = /* @__PURE__ */ n(
  a,
  o,
  l,
  !1,
  null,
  null
);
const u = m.exports;
export {
  u as default
};
